import { useTranslator } from '@bluebeam/react-i18n';
import React from 'react';

type Props = {
  label: string;
  allCount: number;
  errorCount: number;
  inProgressCount: number;
};

const FileManagerCounters: React.FC<Props> = ({
  label,
  allCount,
  errorCount,
  inProgressCount: progressCount,
}) => {
  const { translate } = useTranslator(['fileManagerCounters']);
  return (
    <div className="row mx5 mb3 mt4">
      <div className="font-size-4 medium" style={{ color: '#363d43' }}>
        {translate('fileManagerCounters:all', {
          label,
          allCount,
        })}
      </div>
      <div style={{ flex: '4 4 auto' }} />
      <div className="head7 font-size-4 light black-2">
        <span>
          {translate('fileManagerCounters:errors', {
            count: errorCount,
          })}
        </span>
        <span> • </span>
        <span>
          {translate('fileManagerCounters:inProgress', {
            count: progressCount,
          })}
        </span>
      </div>
    </div>
  );
};

export default FileManagerCounters;
